//  react
import React, { useEffect } from "react";
// aos
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "../Layout/Layout";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { sendMessage } from "../../states/actions/feedbackAction";
import { ToastContainer } from "react-toastify";
import {
  FaLaptopCode,
  FaMobileAlt,
  FaRobot,
  FaPenNib,
  FaChalkboardTeacher,
  FaHandshake,
  FaCogs,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaBalanceScale,
  FaShieldAlt,
  FaGlobe,
} from "react-icons/fa";
import Sectors from "./Sectors";

// service function
const Service = () => {
  // use effect
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 3000 });
  }, []);

  const dispatch = useDispatch();
  // use form
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data, e) => {
    console.log("message sent is : ", data);
    dispatch(sendMessage(data));
    reset();
  };

  const services = [
    {
      icon: <FaLaptopCode className="w-8 h-8 text-[#70513E]" />,
      title: "Litigation, Arbitration & ADR",
      description:
        "Resolving disputes through courts, arbitration, and ADR requires not just legal knowledge, but practical insight into evidence, procedure, and enforcement.",
    },
    {
      icon: <FaMobileAlt className="w-8 h-8 text-[#70513E]" />,
      title: "Mobile App Development",
      description:
        "We build and maintain cross-platform Android and iOS apps using Flutter or React Native to enhance community engagement and learning.",
    },
    {
      icon: <FaRobot className="w-8 h-8 text-[#70513E]" />,
      title: "AI & Machine Learning",
      description:
        "We develop AI-powered tools, including chatbots and data analytics, to support education, mentorship, and youth empowerment through smarter, 24/7 engagement and program improvement.",
    },
    {
      icon: <FaPenNib className="w-8 h-8 text-[#70513E]" />,
      title: "Digital Content Creation",
      description:
        "We offer video production, graphic design, and social media strategies to boost storytelling, training, marketing, and brand visibility.",
    },
    {
      icon: <FaChalkboardTeacher className="w-8 h-8 text-[#70513E]" />,
      title: "Training & Capacity Building",
      description:
        "We provide workshops and bootcamps focused on leadership, tech skills, and career or scholarship preparation to empower personal and professional growth.",
    },
    {
      icon: <FaHandshake className="w-8 h-8 text-[#70513E]" />,
      title: "Partnership & Community Engagement",
      description:
        "We organize events and virtual exchanges, partner with NGOs, universities, and businesses, and manage volunteer and ambassador programs.",
    },
    {
      icon: <FaCogs className="w-8 h-8 text-[#70513E]" />,
      title: "Tech Consulting & Support",
      description:
        "We offer IT setup, software development, and digital transformation support for educational initiatives, nonprofits, and small businesses.",
    },
  ];

  // return
  return (
    <Layout
      title="Service Page | Aderaw Addisu Law Office"
      description="Legal services in Bahir Dar including arbitration, litigation, contracts and consultation."
      keywords="Legal services Bahir Dar, Lawyer Ethiopia"
    >
      <section className="min-h-screen bg-gradient-to-b from-[#1e2f4a] to-[#0b1628] text-white flex items-center justify-center px-6">
        <div className="max-w-5xl w-full text-center">
          {/* Top Badge */}
          <div className="inline-block mb-6">
            <span className="text-[11px] tracking-widest uppercase px-5 py-2 rounded-full border border-yellow-500/40 text-yellow-400">
              Ethiopia’s Premier Law Firm
            </span>
          </div>

          {/* Title */}

          <h1 className="text-5xl md:text-6xl font-light mb-6 leading-tight font-serif">
            Our{" "}
            <span className="text-yellow-400 font-serif font-medium tracking-tight">
              Service
            </span>
          </h1>
          {/* Description */}
          <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-12">
            Ethiopia’s only law firm founded by five former Federal Supreme
            Court and High Court judges. Bringing 114+ years of combined
            judicial experience to every client engagement.
          </p>

          {/* Stats Card */}
          <div className="grid grid-cols-2 md:grid-cols-4 overflow-hidden rounded-xl bg-white/5 backdrop-blur-md border border-white/10">
            {/* Item */}
            <div className="py-8 border-r border-white/10 font-serif">
              <h3 className="text-3xl text-yellow-400  font-semibold">12</h3>
              <p className="text-xs tracking-widest mt-2 text-gray-300">
                LAWYERS
              </p>
              <span className="text-[11px] text-gray-400 mt-2 block">
                08 Total Team
              </span>
            </div>

            <div className="py-8 border-r border-white/10 font-serif">
              <h3 className="text-3xl text-yellow-400 font-semibold">8</h3>
              <p className="text-xs tracking-widest mt-2 text-gray-300">
                FORMER JUDGES
              </p>
              <span className="text-[11px] text-gray-400 mt-2 block">
                14+ Years on Bench
              </span>
            </div>

            <div className="py-8 border-r border-white/10 font-serif">
              <h3 className="text-3xl text-yellow-400 font-semibold">10</h3>
              <p className="text-xs tracking-widest mt-2 text-gray-300">
                Client Focus
              </p>
              <span className="text-[11px] text-gray-400 mt-2 block">
                2 Candidates
              </span>
            </div>

            <div className="py-8 font-serif">
              <h3 className="text-3xl text-yellow-400 font-semibold">5</h3>
              <p className="text-xs tracking-widest mt-2 text-gray-300">
                Languages Served
              </p>
              <span className="text-[11px] text-gray-400 mt-2 block">
                4 Published Authors
              </span>
            </div>
          </div>
        </div>
      </section>

      <Sectors />

      <div className="bg-[#f9f7f3] text-[#2c2c2c]">
        {/* ================= WHY CLIENTS TRUST US ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <h2 className="text-4xl md:text-5xl font-serif text-[#6b3f1d] mb-12">
            Why Clients Trust Us?
          </h2>

          <div className="grid md:grid-cols-3 gap-6 items-stretch">
            {/* LEFT COLUMN */}
            <div className="space-y-6">
              {/* Card 1 */}
              <div className="bg-[#f3ece3] border border-[#e5d6c3] rounded-2xl p-6 shadow-sm">
                <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#d6b98c] text-[#c58b2b] mb-4">
                  <FaBalanceScale />
                </div>

                <h3 className="font-semibold text-lg mb-2">
                  Expert Legal Professionals
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Highly qualified attorneys with decades of combined experience
                  in various legal domains. Real-world expertise to provide you
                  with the most effective legal solutions.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-[#f3ece3] border border-[#e5d6c3] rounded-2xl p-6 shadow-sm">
                <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#d6b98c] text-[#c58b2b] mb-4">
                  <FaGlobe />
                </div>

                <h3 className="font-semibold text-lg mb-2">
                  Comprehensive Legal Services
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Full spectrum of legal services from corporate law to human
                  rights advocacy. Our diverse practice areas ensure all your
                  legal needs are met efficiently.
                </p>
              </div>
            </div>

            {/* CENTER (WIDE CARD) */}
            <div className="bg-[#f3ece3] border border-[#e5d6c3] rounded-2xl p-6 shadow-sm flex flex-col justify-center">
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-[#d6b98c] text-[#c58b2b] mb-4">
                🌐
              </div>

              <h3 className="font-semibold text-lg mb-2">
                Trusted by International Clients
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                We have a proven track record of serving embassies, diplomatic
                missions, international investors, and multinational
                corporations. Our deep understanding of both Ethiopian law and
                international legal frameworks makes us the preferred choice for
                cross-border legal matters.
              </p>
            </div>

            {/* RIGHT HIGHLIGHT CARD */}
            <div className="bg-gradient-to-br from-[#d89b2b] to-[#b96e16] text-white rounded-2xl p-8 shadow-lg flex flex-col justify-between">
              <div>
                <div className="w-12 h-12 flex items-center justify-center rounded-full border border-white mb-5">
                  <FaShieldAlt />
                </div>

                <h3 className="text-xl font-semibold mb-3">
                  Ethical & Reliable Service
                </h3>

                <p className="text-sm leading-relaxed opacity-95">
                  Since 2012, AMALF has been committed to delivering ethical,
                  reliable, and high-standard legal services. We operate in full
                  compliance with Ethiopian law and are duly licensed by the
                  Federal Attorney General. Your trust and confidentiality are
                  our top priorities.
                </p>
              </div>

              <button className="mt-8 bg-[#8b4a0f] hover:bg-[#6f3a0c] transition text-white py-3 rounded-xl font-medium">
                Get Started →
              </button>
            </div>
          </div>
        </section>

        {/* ================= CONTACT SECTION ================= */}
        <section className="max-w-7xl mx-auto px-6 pb-24">
          <h2 className="text-4xl md:text-5xl font-serif text-[#6b3f1d] mb-4">
            Discuss Your Case with Confidence!
          </h2>

          <p className="text-gray-600 max-w-3xl mb-12">
            Contact us using your preferred method and share your details with a
            short description of your matter. Our legal team is ready to listen,
            provide guidance, and support you throughout the process.
          </p>

          <div className="grid md:grid-cols-2 gap-10">
            {/* LEFT CONTACT METHODS */}
            <div className="bg-[#f3ece3] border border-[#e5d6c3] rounded-2xl p-6 space-y-5 shadow-sm">
              {/* WhatsApp */}
              <div className="flex items-center justify-between bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex items-center gap-4">
                  <FaWhatsapp className="text-green-500 text-2xl" />
                  <div>
                    <h4 className="font-semibold">WhatsApp</h4>
                    <p className="text-sm text-[#c58b2b]"> +251-918-784-307</p>
                  </div>
                </div>
                <span className="text-xs bg-green-100 text-green-600 px-2 py-1 rounded-full">
                  Urgent
                </span>
              </div>

              {/* Phone */}
              <div className="flex items-center justify-between bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex items-center gap-4">
                  <FaPhoneAlt className="text-blue-500 text-2xl" />
                  <div>
                    <h4 className="font-semibold">Phone</h4>
                    <p className="text-sm text-[#c58b2b]">
                      +2519-95 98 98 98 / +251-918-784-307
                    </p>
                  </div>
                </div>
                <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full">
                  Urgent
                </span>
              </div>

              {/* Email */}
              <div className="flex items-center justify-between bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex items-center gap-4">
                  <FaEnvelope className="text-red-500 text-2xl" />
                  <div>
                    <h4 className="font-semibold">Email</h4>
                    <p className="text-sm text-[#c58b2b]">aderawLA@gmail.com</p>
                  </div>
                </div>
                <span className="text-xs bg-orange-100 text-orange-600 px-2 py-1 rounded-full">
                  Formal
                </span>
              </div>
            </div>

            {/* RIGHT FORM */}
            <form className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
              <div>
                <label className="text-sm font-medium">Your Full Name</label>
                <input
                  type="text"
                  placeholder="Your Full Name"
                  className="w-full mt-1 border border-[#d6b98c] rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#c58b2b] outline-none"
                  {...register("name", { required: true })}
                />
                {errors.name && (
                  <p className="text-red-500">User Name required</p>
                )}
              </div>

              <div>
                <label className="text-sm font-medium">Phone Number *</label>
                <input
                  type="text"
                  placeholder="Phone Number"
                  className="w-full mt-1 border border-[#d6b98c] rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#c58b2b] outline-none"
                  {...register("phone", { required: true })}
                />
                {errors.phone && <p className="text-red-500">Phone required</p>}
              </div>

              <div>
                <label className="text-sm font-medium">
                  Subject (optional)
                </label>
                <input
                  type="text"
                  placeholder="What is this regarding?"
                  className="w-full mt-1 border border-[#d6b98c] rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#c58b2b] outline-none"
                  {...register("subject")}
                />
              </div>

              <div>
                <label className="text-sm font-medium">Message *</label>
                <textarea
                  rows="5"
                  placeholder="Tell us about your case in a few words..."
                  className="w-full mt-1 border border-[#d6b98c] rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#c58b2b] outline-none"
                  {...register("message", { required: true })}
                ></textarea>
                {errors.message && (
                  <p className="text-red-500">Message is required</p>
                )}
                <p className="text-xs text-gray-400 mt-1">
                  0/5000 characters (minimum 10)
                </p>
              </div>

              <button
                type="submit"
                className="bg-[#d89b2b] hover:bg-[#b96e16] text-white px-6 py-3 rounded-xl font-medium shadow-md transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </section>
      </div>
      <ToastContainer />
    </Layout>
  );
};

// export
export default Service;
